import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  visibilityLabel: {
    id: 'gradebook.GradesTab.usersVisibilityLabel',
    defaultMessage: 'Showing {filteredUsers} of {totalUsers} total learners',
    description: 'Users visibility label',
  },
});

export default messages;
